import { DEFEAT_SECONDS } from './defeat';
import { MeshBuilder } from '@babylonjs/core/pure';
import type { Mesh, Scene } from '@babylonjs/core/pure';
import { buildShadowTexture, toWorldX } from './actors';
import { bossStrafeX, type SimState } from '../sim/sim';
import type { BossSpec } from '../sim/level';

/** Local contact occlusion complements High shadows and grounds bosses on cheaper tiers. */
export class BossContact {
  private readonly mesh: Mesh;
  constructor(scene: Scene, private readonly spec: BossSpec) {
    const tank = spec.kind === 'tank';
    const heli = spec.kind === 'heli';
    this.mesh = MeshBuilder.CreateGround('boss-contact', { width: tank ? 3.1 : heli ? 5 : 3.2, height: tank ? 9.6 : heli ? 5 : 2.2 }, scene);
    this.mesh.position.set(0, 0.025, spec.z);
    this.mesh.material = buildShadowTexture(scene);
    this.mesh.material.alpha = heli ? 0.24 : 0.5;
    this.mesh.isPickable = false;
  }
  update(sim: SimState, presentationAge?: number): void {
    this.mesh.position.x = toWorldX(bossStrafeX(this.spec, sim.t));
    this.mesh.setEnabled(sim.phase !== 'lost' && (sim.phase !== 'won' || presentationAge !== undefined && presentationAge <= DEFEAT_SECONDS) && this.spec.z - sim.squadZ < 120);
  }
}
